import React from 'react';
import { Link } from 'react-router-dom';
import FieldPrint, {fieldCount} from "./FieldPrint";

interface Step2dProps {
  s: {[key: string]: string[]};
  setS: React.Dispatch<React.SetStateAction<{[key: string]: string[]}>>;
  inp: {[key: string]: string};
  setInp: React.Dispatch<React.SetStateAction<{[key: string]: string}>>;
}

function Step2d(props: Step2dProps) {

  const { s, inp, setInp } = props;

  const change = (row: string, value: string) => {
    inp[row] = value;
    setInp({...inp});
  };

  const nobodyLabel = 'niemand';

  const rowIsNobodyLabel = (row: string) => {
    return s[row]
      .filter((f) => f !== '-')
      .every((e) => e === nobodyLabel);
  };

  const rowsAreSame = (r1: string, r2: string) => {
    const row1 = s[r1]
      .filter((f) => f !== '-')
      .filter((value, index, self) => {
        return self.indexOf(value) === index;
      })
      .sort();
    const row2 = s[r2]
      .filter((f) => f !== '-')
      .filter((value, index, self) => {
        return self.indexOf(value) === index;
      })
      .sort();
    return JSON.stringify(row1) === JSON.stringify(row2);
  };

  return (
    <div className="step step2d">
      <h2>Schritt 2: Zuständigkeiten</h2>

      <h3>D) Kommunikation, Beschwerden, Feedback</h3>

      <p>
        Geben Sie hier bitte an, ob zwischen den genannten Personen oder Gruppen formelle oder
        informelle <strong>Kommunikations-/Beschwerde-/Feedbackwege</strong> bestehen.
      </p>

      <form>
        {!(rowIsNobodyLabel('7') || rowIsNobodyLabel('9')) && !rowsAreSame('7', '9') &&
          <fieldset>
            <legend className="fieldDesc">
              Gibt es Kommunikations-/Beschwerde-/Feedbackwege zwischen
              {' '}
              <FieldPrint s={s} row='7' /> {(fieldCount(s, '7') > 1 || fieldCount(s, '9') > 1) && 'einerseits '}und
              {' '}
              <FieldPrint s={s} row='9' />{(fieldCount(s, '7') > 1 || fieldCount(s, '9') > 1) && ' andererseits'}?
            </legend>
            <div id="c23" className="BnRechnerRadioBtn">
              <input type="radio" id="c23yes" name="c23" value="yes" checked={inp['23'] === 'yes'} onChange={() => change('23', 'yes')}/>
              <label htmlFor="c23yes" onClick={() => change('23', 'yes')}>Ja</label>
              <input type="radio" id="c23no" name="c23" value="no" checked={inp['23'] === 'no'} onChange={() => change('23', 'no')}/>
              <label htmlFor="c23no" onClick={() => change('23', 'no')}>Nein</label>
            </div>
          </fieldset>
        }

        {!(rowIsNobodyLabel('7') || rowIsNobodyLabel('5')) && !rowsAreSame('7', '5') &&
          <fieldset>
            <legend className="fieldDesc">
              Gibt es Kommunikations-/Beschwerde-/Feedbackwege zwischen
              {' '}
              <FieldPrint s={s} row='7' /> {(fieldCount(s, '7') > 1 || fieldCount(s, '5') > 1) && 'einerseits '}und
              {' '}
              <FieldPrint s={s} row='5' />{(fieldCount(s, '7') > 1 || fieldCount(s, '5') > 1) && ' andererseits'}?
            </legend>
            <div id="c24" className="BnRechnerRadioBtn">
              <input type="radio" id="c24yes" name="c24" value="yes" checked={inp['24'] === 'yes'} onChange={() => change('24', 'yes')}/>
              <label htmlFor="c24yes" onClick={() => change('24', 'yes')}>Ja</label>
              <input type="radio" id="c24no" name="c24" value="no" checked={inp['24'] === 'no'} onChange={() => change('24', 'no')}/>
              <label htmlFor="c24no" onClick={() => change('24', 'no')}>Nein</label>
            </div>
          </fieldset>
        }

        {!(rowIsNobodyLabel('7') || rowIsNobodyLabel('6')) && !rowsAreSame('7', '6') &&
          <fieldset>
            <legend className="fieldDesc">
              Gibt es Kommunikations-/Beschwerde-/Feedbackwege zwischen
              {' '}
              <FieldPrint s={s} row='7' /> {(fieldCount(s, '7') > 1 || fieldCount(s, '6') > 1) && 'einerseits '}und
              {' '}
              <FieldPrint s={s} row='6' />{(fieldCount(s, '7') > 1 || fieldCount(s, '6') > 1) && ' andererseits'}?
            </legend>
            <div id="c25" className="BnRechnerRadioBtn">
              <input type="radio" id="c25yes" name="c25" value="yes" checked={inp['25'] === 'yes'} onChange={() => change('25', 'yes')}/>
              <label htmlFor="c25yes" onClick={() => change('25', 'yes')}>Ja</label>
              <input type="radio" id="c25no" name="c25" value="no" checked={inp['25'] === 'no'} onChange={() => change('25', 'no')}/>
              <label htmlFor="c25no" onClick={() => change('25', 'no')}>Nein</label>
            </div>
          </fieldset>
        }

        {!(rowIsNobodyLabel('5') || rowIsNobodyLabel('6')) && !rowsAreSame('5', '6') &&
          <fieldset>
            <legend className="fieldDesc">
              Gibt es Kommunikations-/Beschwerde-/Feedbackwege zwischen
              {' '}
              <FieldPrint s={s} row='5' /> {(fieldCount(s, '5') > 1 || fieldCount(s, '6') > 1) && 'einerseits '}und
              {' '}
              <FieldPrint s={s} row='6' />{(fieldCount(s, '5') > 1 || fieldCount(s, '6') > 1) && ' andererseits'}?
            </legend>
            <div id="c26" className="BnRechnerRadioBtn">
              <input type="radio" id="c26yes" name="c26" value="yes" checked={inp['26'] === 'yes'} onChange={() => change('26', 'yes')}/>
              <label htmlFor="c26yes" onClick={() => change('26', 'yes')}>Ja</label>
              <input type="radio" id="c26no" name="c26" value="no" checked={inp['26'] === 'no'} onChange={() => change('26', 'no')}/>
              <label htmlFor="c26no" onClick={() => change('26', 'no')}>Nein</label>
            </div>
          </fieldset>
        }

        {!rowIsNobodyLabel('4') &&
          <fieldset>
            <legend className="fieldDesc">
              Gibt es Kommunikations-/Beschwerde-/Feedbackwege von allen Beteiligten zu
              {' '}
              <FieldPrint s={s} row='4' />?
            </legend>
            <div id="c27" className="BnRechnerRadioBtn">
              <input type="radio" id="c27yes" name="c27" value="yes" checked={inp['27'] === 'yes'} onChange={() => change('27', 'yes')}/>
              <label htmlFor="c27yes" onClick={() => change('27', 'yes')}>Ja</label>
              <input type="radio" id="c27no" name="c27" value="no" checked={inp['27'] === 'no'} onChange={() => change('27', 'no')}/>
              <label htmlFor="c27no" onClick={() => change('27', 'no')}>Nein</label>
            </div>
          </fieldset>
        }
      </form>

      <div className="stepNav">
        <Link className="btn btn-secondary" to="/step2c">Zurück</Link>
        <Link className="btn btn-primary" to="/step3">Weiter</Link>
      </div>
    </div>
  );
}

export default Step2d
;